import React from 'react';

import { ContentModule } from '@nhl/nhl-react-ui/lib/ContentModule';

import TemplateKeys from 'media-base-ui/utils/contentModuleTemplateKeys';

import Birthday from '../birthday';

const RightRail = () => (
    <div className="right-rail">
        <ContentModule templateKey={TemplateKeys.HOME} sequence={1} />
        <ContentModule templateKey={TemplateKeys.HOME} sequence={2} />
        <ContentModule templateKey={TemplateKeys.HOME} sequence={3} />
        <ContentModule templateKey={TemplateKeys.HOME} sequence={4} />
        <ContentModule templateKey={TemplateKeys.HOME} sequence={5} />
        <Birthday />
    </div>
);

export default RightRail;